import React, { useEffect, useState } from 'react';
import { StatusBadge } from '../../components/admin/StatusBadge';

export const OrderList: React.FC = () => {
  const [orders, setOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/sample-orders', { credentials: 'include' })
      .then(r => r.json())
      .then(data => { setOrders(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const updateStatus = async (id: string, status: string) => {
    const res = await fetch('/api/admin/sample-orders', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ id, status }),
    });
    if (res.ok) {
      setOrders(prev => prev.map(o => o.id === id ? { ...o, status } : o));
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-[#1A1A1A] tracking-tight">Sample Orders</h1>
          <p className="text-sm text-[#A3A3A3] mt-1">{orders.length} total orders</p>
        </div>
      </div>

      {loading ? (
        <div className="space-y-3">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="h-16 bg-white rounded-2xl animate-pulse shadow-sm" />
          ))}
        </div>
      ) : (
        <div className="bg-white border border-[#E8E6E2]/60 rounded-2xl overflow-hidden shadow-sm shadow-black/[0.03]">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-[#E8E6E2]/60 bg-[#FAFAF8]/50">
                <th className="px-5 py-3.5 text-left text-[11px] text-[#A3A3A3] uppercase tracking-[0.12em] font-semibold">Name</th>
                <th className="px-5 py-3.5 text-left text-[11px] text-[#A3A3A3] uppercase tracking-[0.12em] font-semibold">Company</th>
                <th className="px-5 py-3.5 text-left text-[11px] text-[#A3A3A3] uppercase tracking-[0.12em] font-semibold">Email</th>
                <th className="px-5 py-3.5 text-left text-[11px] text-[#A3A3A3] uppercase tracking-[0.12em] font-semibold">Ship To</th>
                <th className="px-5 py-3.5 text-left text-[11px] text-[#A3A3A3] uppercase tracking-[0.12em] font-semibold">Shipping</th>
                <th className="px-5 py-3.5 text-left text-[11px] text-[#A3A3A3] uppercase tracking-[0.12em] font-semibold">Coffees</th>
                <th className="px-5 py-3.5 text-left text-[11px] text-[#A3A3A3] uppercase tracking-[0.12em] font-semibold">Date</th>
                <th className="px-5 py-3.5 text-left text-[11px] text-[#A3A3A3] uppercase tracking-[0.12em] font-semibold">Status</th>
              </tr>
            </thead>
            <tbody>
              {orders.map(o => {
                const fullAddress = [o.addressLine1, o.addressLine2, o.city, o.stateProvince, o.postalCode, o.country]
                  .filter(Boolean).join(', ');
                const isRow = o.shippingRegion === 'row';
                return (
                <tr key={o.id} className="border-b border-[#E8E6E2]/60 last:border-0 hover:bg-[#FAFAF8]/50 transition-colors">
                  <td className="px-5 py-4 font-semibold text-[#1A1A1A]">{o.name}</td>
                  <td className="px-5 py-4 text-[#6B6B6B]">{o.company}</td>
                  <td className="px-5 py-4 text-[#6B6B6B]">{o.email}</td>
                  <td className="px-5 py-4 text-[#6B6B6B] max-w-[220px] truncate" title={fullAddress}>
                    {fullAddress || '—'}
                  </td>
                  <td className="px-5 py-4">
                    {o.shippingRegion ? (
                      <span className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-lg ${
                        isRow ? 'bg-orange-50 text-orange-700' : 'bg-green-50 text-green-700'
                      }`}>
                        {isRow ? `$${o.shippingCost} DHL${o.phytosanitaryRequired ? ' + phyto' : ''}` : 'Free (UK/EU)'}
                      </span>
                    ) : '—'}
                  </td>
                  <td className="px-5 py-4 text-[#6B6B6B] max-w-[200px] truncate">
                    {Array.isArray(o.requestedCoffees) ? o.requestedCoffees.join(', ') : o.requestedCoffees}
                  </td>
                  <td className="px-5 py-4 text-[#6B6B6B] tabular-nums">{o.orderDate}</td>
                  <td className="px-5 py-4">
                    <select
                      value={o.status}
                      onChange={e => updateStatus(o.id, e.target.value)}
                      className="text-xs font-medium border border-[#E8E6E2] rounded-lg px-2.5 py-1.5 bg-[#FAFAF8] text-[#1A1A1A] focus:outline-none focus:ring-2 focus:ring-[#1A1A1A]/10 focus:border-[#1A1A1A]/30 transition-all cursor-pointer"
                    >
                      <option value="New">New</option>
                      <option value="Processing">Processing</option>
                      <option value="Fulfilled">Fulfilled</option>
                      <option value="Cancelled">Cancelled</option>
                    </select>
                  </td>
                </tr>
                );
              })}
            </tbody>
          </table>
          {orders.length === 0 && (
            <div className="p-12 text-center">
              <p className="text-[#A3A3A3]">No orders yet.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
